import * as React from 'react'

import {
  City,
  FirstName,
  FormGroup,
  HouseNumberSuffix,
  LastName,
  PostalCode,
  Region,
  Street,
} from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

import { isPostalCode } from '../../util/form-validation'
import { FormProps } from './types'

const AddressForm: React.FC<FormProps> = () => {
  const { getLabel } = useIntl()

  return (
    <React.Fragment>
      <FormGroup columns={2}>
        <FirstName
          label={getLabel('checkout.contact.firstName')}
          errorMessage={getLabel('checkout.contact.firstName.errorMessage')}
          maxLength={30}
        />
        <LastName
          label={getLabel('checkout.contact.lastName')}
          errorMessage={getLabel('checkout.contact.lastName.errorMessage')}
          maxLength={255}
        />
      </FormGroup>
      <FormGroup>
        <Street
          label={getLabel('checkout.address.street')}
          errorMessage={getLabel('checkout.address.street.errorMessage')}
          maxLength={50}
        />
      </FormGroup>
      <FormGroup>
        <HouseNumberSuffix
          required={false}
          label={getLabel('checkout.address.streetNumber.suffix')}
          optionalText={getLabel('checkout.form.field.optional')}
          maxLength={50}
        />
      </FormGroup>
      <FormGroup columns={2}>
        <City
          label={getLabel('checkout.address.city')}
          errorMessage={getLabel('checkout.address.city.errorMessage')}
          maxLength={50}
        />
        <PostalCode
          label={getLabel('checkout.address.postalCode')}
          validations={[isPostalCode]}
          errorMessage={getLabel('checkout.address.postalCode.errorMessage')}
        />
      </FormGroup>
      <FormGroup>
        <Region
          label={getLabel('checkout.address.district')}
          errorMessage={getLabel('checkout.address.district.errorMessage')}
          maxLength={35}
        />
      </FormGroup>
    </React.Fragment>
  )
}

export const CheckoutAddressForm = () => <AddressForm />

export default AddressForm
